(function () {
  'use strict';

  if (window.__cscNativeAddonsInstalled) return;
  window.__cscNativeAddonsInstalled = true;

  var config = window.CSC_NATIVE_ADDONS_CONFIG || {};
  var targetHandle = config.targetHandle || 'land-rover-discovery-sport-car-window-shades';
  var currentPath = window.location.pathname || '';

  if (currentPath.indexOf('/products/' + targetHandle) === -1) return;

  var state = {
    submitting: false,
    form: null,
    container: null,
    error: null,
    modal: null,
    lastModalTrigger: null,
    primaryVariants: Array.isArray(config.product && config.product.variants) ? config.product.variants : [],
    addons: Array.isArray(config.addons) ? config.addons.filter(function (addon) {
      return addon && addon.handle && Array.isArray(addon.variants) && addon.variants.length;
    }) : []
  };

  if (!state.addons.length) return;

  function money(cents) {
    var number = Number(cents || 0) / 100;
    return '$' + number.toFixed(2);
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value || '').replace(/"/g, '\\"');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+-\s+unavailable\s*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getVariantTitle(variant) {
    if (!variant) return '';
    if (variant.public_title) return variant.public_title;
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    if (variant.option1 && variant.option1 !== 'Default Title') return variant.option1;
    return '';
  }

  function variantOptionValues(variant) {
    var values = [];

    if (!variant) return values;

    ['option1', 'option2', 'option3', 'public_title', 'title'].forEach(function (key) {
      if (variant[key] && variant[key] !== 'Default Title') values.push(String(variant[key]));
    });

    if (Array.isArray(variant.options)) {
      variant.options.forEach(function (value) {
        if (value && value !== 'Default Title') values.push(String(value));
      });
    }

    return values.reduce(function (result, value) {
      value.split(' / ').forEach(function (part) {
        var normalized = normalize(part);
        if (normalized) result.push(part);
      });
      return result;
    }, []);
  }

  function variantAlreadyShowsValue(variant, value) {
    var wanted = normalize(value);
    if (!wanted) return false;

    return variantOptionValues(variant).some(function (candidate) {
      var normalized = normalize(candidate);
      return normalized === wanted;
    });
  }

  function getPrimaryVariantId() {
    var idInput = state.form && state.form.querySelector('[name="id"]');
    return idInput ? String(idInput.value || '') : '';
  }

  function getPrimaryVariant() {
    var selectedId = getPrimaryVariantId();
    for (var i = 0; i < state.primaryVariants.length; i += 1) {
      if (String(state.primaryVariants[i].id) === selectedId) return state.primaryVariants[i];
    }
    return state.primaryVariants[0] || null;
  }

  function getSelectedOptionValue(matchers) {
    var controls = state.form ? state.form.querySelectorAll('select, input[type="radio"]:checked') : [];
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      var labelText = '';
      var name = control.getAttribute('name') || '';

      if (name.indexOf('options[') === 0) {
        labelText = name.replace(/^options\[/, '').replace(/\]$/, '');
      }

      if (!labelText) {
        var id = control.getAttribute('id');
        var label = id ? document.querySelector('label[for="' + escapeSelector(id) + '"]') : null;
        labelText = label ? label.textContent : '';
      }

      var normalizedLabel = normalize(labelText);
      var isMatch = matchers.some(function (matcher) {
        return normalizedLabel.indexOf(matcher) !== -1;
      });

      if (isMatch) {
        var value = control.tagName === 'SELECT'
          ? control.options[control.selectedIndex] && control.options[control.selectedIndex].text
          : control.value;
        return String(value || '').replace(/\s+-\s+Unavailable\s*$/i, '').trim();
      }
    }

    return '';
  }

  function meaningfulOptionValue(value) {
    var text = String(value || '').replace(/\s+-\s+Unavailable\s*$/i, '').trim();
    return text && text !== 'Default Title' ? text : '';
  }

  function variantOptionValue(variant, position) {
    if (!variant) return '';
    return meaningfulOptionValue(variant['option' + position]);
  }

  function productOptionName(position) {
    var options = Array.isArray(config.product && config.product.options) ? config.product.options : [];
    var option = options[position - 1];

    if (typeof option === 'string') return option;
    if (option && option.name) return option.name;

    return '';
  }

  function productOptionMatches(position, matchers) {
    var optionName = normalize(productOptionName(position));
    if (!optionName) return false;

    return matchers.some(function (matcher) {
      return optionName.indexOf(matcher) !== -1;
    });
  }

  function variantOptionValueByName(variant, matchers) {
    for (var position = 1; position <= 3; position += 1) {
      if (productOptionMatches(position, matchers)) {
        var value = variantOptionValue(variant, position);
        if (value) return value;
      }
    }

    return '';
  }

  function yearFromVariant(variant) {
    var namedYear = variantOptionValueByName(variant, ['year']);
    if (namedYear) return namedYear;

    var option2 = variantOptionValue(variant, 2);
    if (option2) return option2;

    var option1 = variantOptionValue(variant, 1);
    if (option1) return option1;

    var title = getVariantTitle(variant);
    if (title.indexOf(' / ') !== -1) {
      var parts = title.split(' / ').map(meaningfulOptionValue).filter(Boolean);
      return parts[parts.length - 1] || title;
    }

    return title;
  }

  function bodyFromVariant(variant) {
    var namedBody = variantOptionValueByName(variant, ['body']);
    if (namedBody) return namedBody;

    if (variantOptionValue(variant, 2)) return variantOptionValue(variant, 1);

    return '';
  }

  function getSelectedDetails() {
    var variant = getPrimaryVariant();
    var variantYear = yearFromVariant(variant);
    var selectedYear = getSelectedOptionValue(['year']);
    var year = selectedYear && selectedYear.indexOf(' / ') === -1 ? selectedYear : variantYear;
    var body = getSelectedOptionValue(['body']) || bodyFromVariant(variant);

    return {
      variant: variant,
      year: year,
      body: body
    };
  }

  function variantMatchesDetails(variant, details) {
    var values = variantOptionValues(variant).map(normalize);
    var wantedYear = normalize(details && details.year);
    var wantedBody = normalize(details && details.body);

    if (wantedBody && values.indexOf(wantedBody) === -1) return false;
    if (wantedYear && values.indexOf(wantedYear) === -1) return false;

    return !!(wantedYear || wantedBody);
  }

  function findAddonVariant(addon, selectedDetails) {
    var variants = addon.variants || [];
    var details = typeof selectedDetails === 'string' ? { year: selectedDetails } : selectedDetails || {};
    var fallback = null;
    var unavailableMatch = null;

    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      if (!fallback && variant.available !== false) fallback = variant;

      if (variantMatchesDetails(variant, details)) {
        if (variant.available !== false) return variant;
        if (!unavailableMatch) unavailableMatch = variant;
      }
    }

    return unavailableMatch || fallback || variants[0] || null;
  }

  function isPrimaryAddon(addon) {
    return !!(addon && (addon.isPrimary || addon.handle === targetHandle));
  }

  function addonImage(addon) {
    return addon.image || (addon.featured_image && addon.featured_image.src) || '';
  }

  function productBaseTitle() {
    var title = String((config.product && config.product.title) || '').trim();

    return title
      .replace(/\s+Car\s+Window\s+Shades\s*$/i, '')
      .replace(/\s+Window\s+Shades\s*$/i, '')
      .trim();
  }

  function addonDisplayTitle(addon) {
    var title = String((addon && (addon.displayTitle || addon.title)) || '').trim();
    var base = productBaseTitle();

    if (base && title.toLowerCase().indexOf(base.toLowerCase()) === 0) {
      title = title.slice(base.length).trim().replace(/^[-:]\s*/, '').trim();
    }

    return title || String((addon && addon.title) || '').trim() || 'Shade';
  }

  function addonDescription(addon) {
    var description = String((addon && addon.description) || '').trim();
    if (description) return description;

    var title = addonDisplayTitle(addon).toLowerCase();
    var base = productBaseTitle() || 'your vehicle';

    if (title.indexOf('side port') !== -1) {
      return 'Protect your family from the Australian sun with side port window shades that perfectly fit your ' + base + '.';
    }

    if (title.indexOf('rear windscreen') !== -1) {
      return 'Keep your cabin cooler with a rear windscreen shade that perfectly fits your ' + base + '.';
    }

    if (title.indexOf('front windscreen') !== -1) {
      return 'Keep your cabin cooler with a front windscreen sun shade that perfectly fits your ' + base + '.';
    }

    return 'Protect your family from the Australian sun with a pair of rear window shades that perfectly fit your ' + base + '.';
  }

  function injectStyles() {
    if (document.getElementById('csc-native-addons-styles')) return;

    var style = document.createElement('style');
    style.id = 'csc-native-addons-styles';
    style.textContent = [
      '.csc-native-addons{margin:2.2rem 0 1.6rem;}',
      '.csc-native-addons__heading{font-size:2.4rem;line-height:1.25;margin:0 0 1.2rem;font-weight:400;letter-spacing:0;}',
      '.csc-native-addons__list{display:grid;gap:0.8rem;}',
      '.csc-native-addons__card{display:grid;grid-template-columns:1.8rem 9.2rem minmax(0,1fr);align-items:center;gap:1.2rem;min-height:10.4rem;padding:1.2rem;border:0.1rem solid rgba(18,18,18,.18);border-radius:0.6rem;background:#fff;cursor:pointer;}',
      '.csc-native-addons__card:hover{border-color:rgba(18,18,18,.34);}',
      '.csc-native-addons__checkbox{width:1.6rem;height:1.6rem;margin:0;}',
      '.csc-native-addons__image-wrap{display:flex;align-items:center;justify-content:center;width:9.2rem;height:7.4rem;padding:0;border:0;background:transparent;cursor:pointer;}',
      '.csc-native-addons__image{display:block;max-width:9.2rem;max-height:7.4rem;width:auto;height:auto;object-fit:contain;}',
      '.csc-native-addons__text{min-width:0;}',
      '.csc-native-addons__title{display:block;width:100%;padding:0;border:0;background:transparent;text-align:left;font:inherit;font-size:1.5rem;line-height:1.35;color:rgb(var(--color-foreground));cursor:pointer;}',
      '.csc-native-addons__title:hover{text-decoration:underline;text-underline-offset:0.2rem;}',
      '.csc-native-addons__price{display:block;font-size:1.4rem;line-height:1.4;color:rgb(var(--color-foreground));margin-top:0.2rem;}',
      '.csc-native-addons__error{color:#b3261e;font-size:1.4rem;line-height:1.4;text-align:right;margin:0.8rem 0 0;}',
      '.csc-native-addons__error[hidden]{display:none;}',
      '.csc-native-addons-modal-open{overflow:hidden;}',
      '.csc-native-addons-modal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:2rem;background:rgba(18,18,18,.48);}',
      '.csc-native-addons-modal[hidden]{display:none;}',
      '.csc-native-addons-modal__panel{position:relative;display:grid;grid-template-columns:minmax(12rem,22rem) minmax(0,1fr);gap:2rem;width:min(66rem,100%);max-height:calc(100vh - 4rem);overflow:auto;padding:2.4rem;border-radius:0.8rem;background:#fff;box-shadow:0 2.4rem 6rem rgba(18,18,18,.22);}',
      '.csc-native-addons-modal__close{position:absolute;top:0.8rem;right:0.8rem;width:4rem;height:4rem;border:0;background:transparent;font-size:2.6rem;line-height:1;cursor:pointer;color:rgb(var(--color-foreground));}',
      '.csc-native-addons-modal__media{display:flex;align-items:center;justify-content:center;min-height:16.5rem;}',
      '.csc-native-addons-modal__image{display:block;max-width:100%;max-height:22rem;width:auto;height:auto;object-fit:contain;}',
      '.csc-native-addons-modal__body{min-width:0;padding-right:2rem;}',
      '.csc-native-addons-modal__title{margin:0 0 0.7rem;font-size:2.2rem;line-height:1.25;font-weight:400;letter-spacing:0;}',
      '.csc-native-addons-modal__price{margin:0 0 1rem;font-size:1.6rem;line-height:1.4;}',
      '.csc-native-addons-modal__detail{margin:0.2rem 0;font-size:1.4rem;line-height:1.45;color:rgba(18,18,18,.74);}',
      '.csc-native-addons-modal__description{margin:1.2rem 0 0;font-size:1.55rem;line-height:1.55;color:rgb(var(--color-foreground));}',
      '.csc-native-addons-modal__actions{display:flex;flex-wrap:wrap;justify-content:center;gap:0.8rem;margin-top:1.8rem;}',
      '.csc-native-addons-modal__select{min-height:4.4rem;padding:0 2.4rem;border:0;border-radius:999px;background:#df6b1d;color:#fff;font:inherit;font-weight:700;cursor:pointer;}',
      'body.csc-native-addons-active .lb-upsell-product-page-card,body.csc-native-addons-active .lb-upsell-ppa-card-cont,body.csc-native-addons-active lb-upsell-product-page-addon,body.csc-native-addons-active .lb-addon,body.csc-native-addons-active .lb-upsell-widget,body.csc-native-addons-active .lb-product-card{display:none!important;}',
      '@media screen and (max-width: 749px){.csc-native-addons{margin:1.8rem 0 1.4rem;}.csc-native-addons__heading{font-size:2.2rem;}.csc-native-addons__card{grid-template-columns:1.8rem 10.8rem minmax(0,1fr);gap:1rem;min-height:10.8rem;padding:1rem;}.csc-native-addons__image-wrap{width:10.8rem;height:8.6rem;}.csc-native-addons__image{max-width:10.8rem;max-height:8.6rem;}.csc-native-addons__title{font-size:1.45rem;}.csc-native-addons-modal{padding:1.6rem;align-items:center;box-sizing:border-box;}.csc-native-addons-modal__panel{grid-template-columns:1fr;gap:1rem;width:min(100%,42rem);max-height:calc(100vh - 3.2rem);max-height:calc(100dvh - 3.2rem);padding:2rem;border-radius:0.8rem;}.csc-native-addons-modal__body{padding-right:0;}.csc-native-addons-modal__title{font-size:2rem;}.csc-native-addons-modal__media{min-height:13.2rem;}.csc-native-addons-modal__image{max-height:16.5rem;}}'
    ].join('');

    document.head.appendChild(style);
  }

  function setAddonChecked(index, checked) {
    if (!state.container) return;

    var row = state.container.querySelector('[data-csc-addon-index="' + escapeSelector(String(index)) + '"]');
    var checkbox = row ? row.querySelector('[data-csc-addon-checkbox]') : null;

    if (!checkbox) return;

    checkbox.checked = checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function closeAddonModal() {
    if (!state.modal) return;

    state.modal.remove();
    state.modal = null;
    document.body.classList.remove('csc-native-addons-modal-open');

    if (state.lastModalTrigger && typeof state.lastModalTrigger.focus === 'function') {
      state.lastModalTrigger.focus();
    }

    state.lastModalTrigger = null;
  }

  function openAddonModal(index, trigger) {
    var addon = state.addons[index];
    var details = getSelectedDetails();
    var variant = addon ? findAddonVariant(addon, details) : null;

    if (!addon || !variant) return;

    closeAddonModal();
    state.lastModalTrigger = trigger || document.activeElement;

    var displayTitle = addonDisplayTitle(addon);
    var overlay = document.createElement('div');
    overlay.className = 'csc-native-addons-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', displayTitle || 'Product details');

    var panel = document.createElement('div');
    panel.className = 'csc-native-addons-modal__panel';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'csc-native-addons-modal__close';
    close.setAttribute('aria-label', 'Close');
    close.textContent = 'x';

    var media = document.createElement('div');
    media.className = 'csc-native-addons-modal__media';

    var imageSrc = addonImage(addon);
    if (imageSrc) {
      var image = document.createElement('img');
      image.className = 'csc-native-addons-modal__image';
      image.src = imageSrc;
      image.alt = displayTitle || '';
      media.appendChild(image);
    }

    var body = document.createElement('div');
    body.className = 'csc-native-addons-modal__body';

    var title = document.createElement('h3');
    title.className = 'csc-native-addons-modal__title';
    title.textContent = displayTitle || '';

    var price = document.createElement('p');
    price.className = 'csc-native-addons-modal__price';
    price.textContent = money(variant.price);

    body.appendChild(title);
    body.appendChild(price);

    var descriptionText = addonDescription(addon);
    if (descriptionText) {
      var description = document.createElement('p');
      description.className = 'csc-native-addons-modal__description';
      description.textContent = descriptionText;
      body.appendChild(description);
    }

    var actions = document.createElement('div');
    actions.className = 'csc-native-addons-modal__actions';

    var select = document.createElement('button');
    select.type = 'button';
    select.className = 'csc-native-addons-modal__select';
    select.textContent = 'Select this shade';

    actions.appendChild(select);
    body.appendChild(actions);

    panel.appendChild(close);
    panel.appendChild(media);
    panel.appendChild(body);
    overlay.appendChild(panel);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay || event.target === close) {
        event.preventDefault();
        closeAddonModal();
      }
    });

    select.addEventListener('click', function () {
      setAddonChecked(index, true);
      closeAddonModal();
    });

    document.body.appendChild(overlay);
    document.body.classList.add('csc-native-addons-modal-open');
    state.modal = overlay;
    close.focus();
  }

  function handleAddonListClick(event) {
    var modalTrigger = event.target && event.target.closest ? event.target.closest('[data-csc-addon-modal]') : null;

    if (modalTrigger && state.container && state.container.contains(modalTrigger)) {
      var modalRow = modalTrigger.closest('[data-csc-addon-index]');
      if (!modalRow) return;

      event.preventDefault();
      event.stopPropagation();
      openAddonModal(Number(modalRow.getAttribute('data-csc-addon-index')), modalTrigger);
      return;
    }

    if (event.target && event.target.closest && event.target.closest('input,button,a,select,textarea')) return;

    var row = event.target && event.target.closest ? event.target.closest('[data-csc-addon-index]') : null;
    if (!row || !state.container || !state.container.contains(row)) return;

    var checkbox = row.querySelector('[data-csc-addon-checkbox]');
    if (!checkbox) return;

    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleEscape(event) {
    if (event.key === 'Escape') closeAddonModal();
  }

  function renderAddons() {
    var details = getSelectedDetails();
    var wrapper = document.createElement('div');
    wrapper.className = 'csc-native-addons';
    wrapper.setAttribute('data-csc-native-addons', '');

    var heading = document.createElement('h2');
    heading.className = 'csc-native-addons__heading';
    heading.textContent = 'Choose your shades';
    wrapper.appendChild(heading);

    var list = document.createElement('div');
    list.className = 'csc-native-addons__list';

    state.addons.forEach(function (addon, index) {
      var variant = findAddonVariant(addon, details);
      if (!variant) return;

      var displayTitle = addonDisplayTitle(addon);
      var card = document.createElement('div');
      card.className = 'csc-native-addons__card';
      card.setAttribute('data-csc-addon-index', String(index));

      var checkbox = document.createElement('input');
      checkbox.className = 'csc-native-addons__checkbox';
      checkbox.type = 'checkbox';
      checkbox.checked = index === 0;
      checkbox.setAttribute('data-csc-addon-checkbox', '');
      checkbox.setAttribute('aria-label', 'Select ' + (displayTitle || 'this shade'));

      var imageWrap = document.createElement('button');
      imageWrap.type = 'button';
      imageWrap.className = 'csc-native-addons__image-wrap';
      imageWrap.setAttribute('data-csc-addon-modal', '');
      imageWrap.setAttribute('aria-label', 'View ' + (displayTitle || 'this shade'));

      var imageSrc = addonImage(addon);
      if (imageSrc) {
        var image = document.createElement('img');
        image.className = 'csc-native-addons__image';
        image.src = imageSrc;
        image.alt = '';
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      }

      var text = document.createElement('span');
      text.className = 'csc-native-addons__text';

      var title = document.createElement('button');
      title.type = 'button';
      title.className = 'csc-native-addons__title';
      title.setAttribute('data-csc-addon-modal', '');
      title.textContent = displayTitle || '';

      var price = document.createElement('span');
      price.className = 'csc-native-addons__price';
      price.setAttribute('data-csc-addon-price', '');
      price.textContent = money(variant.price);

      text.appendChild(title);
      text.appendChild(price);
      card.appendChild(checkbox);
      card.appendChild(imageWrap);
      card.appendChild(text);
      list.appendChild(card);
    });

    list.addEventListener('click', handleAddonListClick);

    var error = document.createElement('p');
    error.className = 'csc-native-addons__error';
    error.hidden = true;
    error.textContent = 'Select a product to continue';

    wrapper.appendChild(list);
    wrapper.appendChild(error);
    state.error = error;

    return wrapper;
  }

  function updateAddonPrices() {
    if (!state.container) return;
    var details = getSelectedDetails();
    var rows = state.container.querySelectorAll('[data-csc-addon-index]');

    rows.forEach(function (row) {
      var addon = state.addons[Number(row.getAttribute('data-csc-addon-index'))];
      var variant = findAddonVariant(addon, details);
      var price = row.querySelector('[data-csc-addon-price]');
      if (price && variant) price.textContent = money(variant.price);
    });
  }

  function getCheckedAddons() {
    var checked = state.container ? state.container.querySelectorAll('[data-csc-addon-checkbox]:checked') : [];
    var details = getSelectedDetails();
    var results = [];

    checked.forEach(function (checkbox) {
      var row = checkbox.closest('[data-csc-addon-index]');
      var addon = row ? state.addons[Number(row.getAttribute('data-csc-addon-index'))] : null;
      var variant = addon ? findAddonVariant(addon, details) : null;
      if (addon && variant) {
        results.push({
          addon: addon,
          variant: variant
        });
      }
    });

    return results;
  }

  function getCartRenderer() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function waitForCustomElement(name, timeout) {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') {
      return wait(0);
    }

    if (window.customElements.get(name)) {
      return wait(0);
    }

    return Promise.race([
      window.customElements.whenDefined(name).catch(function () {}),
      wait(timeout || 1500)
    ]);
  }

  async function getReadyCartRenderer() {
    var renderer = getCartRenderer();

    if (renderer && typeof renderer.renderContents === 'function' && typeof renderer.getSectionsToRender === 'function') {
      return renderer;
    }

    if (document.querySelector('cart-notification')) {
      await waitForCustomElement('cart-notification', 1500);
    }

    if (document.querySelector('cart-drawer')) {
      await waitForCustomElement('cart-drawer', 1500);
    }

    renderer = getCartRenderer();
    return renderer;
  }

  function getSections(cartRenderer) {
    if (cartRenderer && typeof cartRenderer.getSectionsToRender === 'function') {
      return cartRenderer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function getSectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html || '', 'text/html');
    var element = selector ? parsed.querySelector(selector) : parsed.querySelector('.shopify-section');
    return element ? element.innerHTML : '';
  }

  function clearCartDrawerEmptyState() {
    var drawer = document.querySelector('cart-drawer');
    var hasItems = !!document.querySelector('#CartDrawer-CartItems .cart-item, cart-drawer .cart-item');
    if (!hasItems) return;

    [
      drawer,
      document.querySelector('cart-drawer-items'),
      document.querySelector('#CartDrawer'),
      document.querySelector('#CartDrawer .drawer__inner')
    ].forEach(function (element) {
      if (element && element.classList) element.classList.remove('is-empty');
    });
  }

  function setLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');

    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function makeProperties(details, flags) {
    var properties = {};
    var options = flags || {};
    var lineVariant = options.variant || null;

    if (details.body && !variantAlreadyShowsValue(lineVariant, details.body)) properties['Body type'] = details.body;
    if (details.year && !variantAlreadyShowsValue(lineVariant, details.year)) properties.Year = details.year;

    properties._csc_source_variant_id = String(details.variant && details.variant.id ? details.variant.id : getPrimaryVariantId());
    properties._csc_source_handle = targetHandle;
    properties._csc_native_visible = 'true';

    if (options.visiblePrimary) {
      properties._csc_visible_primary = 'true';
    }

    if (options.hiddenParent) {
      properties._csc_hidden_parent = 'true';
      properties._hidden_in_checkout = 'true';
    }

    return properties;
  }

  function renderCart(cartRenderer, parsed) {
    if (cartRenderer && parsed && parsed.sections && typeof cartRenderer.renderContents === 'function') {
      if (typeof cartRenderer.setActiveElement === 'function') {
        cartRenderer.setActiveElement(document.activeElement);
      }

      cartRenderer.renderContents(parsed);
      clearCartDrawerEmptyState();
      window.setTimeout(clearCartDrawerEmptyState, 50);
      return;
    }

    if (parsed && parsed.sections) {
      var cartDrawer = document.querySelector('cart-drawer');
      var cartDrawerSection = parsed.sections['cart-drawer'];
      var cartBubbleSection = parsed.sections['cart-icon-bubble'];

      if (cartDrawer && cartDrawerSection) {
        var drawerTarget = document.querySelector('#CartDrawer');
        var drawerHtml = getSectionInnerHTML(cartDrawerSection, '#CartDrawer');

        if (drawerTarget && drawerHtml) {
          drawerTarget.innerHTML = drawerHtml;
        }

        cartDrawer.classList.remove('is-empty');

        var drawerInner = cartDrawer.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');
        clearCartDrawerEmptyState();

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open(document.querySelector('#cart-icon-bubble') || document.activeElement);
        } else {
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }

        window.setTimeout(clearCartDrawerEmptyState, 50);
      }

      if (cartBubbleSection) {
        var bubble = document.querySelector('#cart-icon-bubble');
        var bubbleHtml = getSectionInnerHTML(cartBubbleSection);
        if (bubble && bubbleHtml) bubble.innerHTML = bubbleHtml;
      }

      return;
    }

    window.location.href = cartRoot() + 'cart';
  }

  function syncHiddenMetadata(hiddenItems) {
    var tasks = [];

    if (hiddenItems.length && typeof window.appendHiddenProductsToCartAttributes === 'function') {
      tasks.push(window.appendHiddenProductsToCartAttributes(hiddenItems));
    }

    if (typeof window.reconcileHiddenProductsVisibility === 'function') {
      tasks.push(window.reconcileHiddenProductsVisibility());
    }

    if (!tasks.length) return;

    Promise.all(tasks).catch(function (error) {
      console.warn('[CSC native add-ons] Cart metadata sync skipped', error);
    });
  }

  function getSubmitButton() {
    return state.form ? state.form.querySelector('[type="submit"]') : null;
  }

  function isNativeSubmitTrigger(target) {
    if (!state.form || !state.container) return;

    if (!target || typeof target.closest !== 'function') return false;

    var button = target.closest('button[type="submit"], input[type="submit"], [type="submit"]');
    return !!(button && state.form.contains(button));
  }

  function interceptNativeClick(event) {
    if (!isNativeSubmitTrigger(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    submitNativeAddons();
  }

  function interceptNativeSubmit(event) {
    if (!state.form || !state.container) return;
    if (event.target !== state.form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    submitNativeAddons();
  }

  async function submitNativeAddons() {
    if (!state.form || !state.container) return;
    if (state.submitting) return;

    var details = getSelectedDetails();
    var checkedAddons = getCheckedAddons();

    if (!checkedAddons.length) {
      if (state.error) state.error.hidden = false;
      return;
    }

    if (state.error) state.error.hidden = true;

    var button = getSubmitButton();
    var cartRenderer = await getReadyCartRenderer();
    var sections = getSections(cartRenderer);
    var hiddenItemsForAttributes = [];
    var items = [];

    checkedAddons.forEach(function (entry) {
      var primaryAddon = isPrimaryAddon(entry.addon);
      var properties = makeProperties(details, {
        visiblePrimary: primaryAddon,
        variant: entry.variant
      });

      items.push({
        id: Number(entry.variant.id),
        quantity: 1,
        properties: properties
      });
    });

    state.submitting = true;
    setLoading(button, true);

    try {
      var response = await fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: sections,
          sections_url: window.location.pathname
        })
      });

      var parsed = await response.json();
      if (!response.ok) throw new Error(parsed && parsed.description ? parsed.description : 'Unable to add products to cart');

      var addedItems = Array.isArray(parsed.items) ? parsed.items : [];
      hiddenItemsForAttributes = addedItems.filter(function (item) {
        return item && item.properties && item.properties._csc_hidden_parent === 'true';
      });

      renderCart(cartRenderer, parsed);
      syncHiddenMetadata(hiddenItemsForAttributes);

    } catch (error) {
      if (state.error) {
        state.error.textContent = error.message || 'Unable to add products to cart';
        state.error.hidden = false;
      }
      console.error('[CSC native add-ons]', error);
    } finally {
      state.submitting = false;
      setLoading(button, false);
    }
  }

  function install() {
    if (state.container) return;

    state.form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!state.form) return;

    injectStyles();
    document.body.classList.add('csc-native-addons-active');

    var buttons = state.form.querySelector('.product-form__buttons') || state.form.querySelector('[type="submit"]');
    var insertionPoint = buttons && buttons.parentNode ? buttons : state.form.querySelector('[type="submit"]');

    state.container = renderAddons();

    if (insertionPoint && insertionPoint.parentNode) {
      insertionPoint.parentNode.insertBefore(state.container, insertionPoint);
    } else {
      state.form.appendChild(state.container);
    }

    state.form.addEventListener('change', function () {
      window.setTimeout(updateAddonPrices, 0);
    });

    document.addEventListener('click', interceptNativeClick, true);
    document.addEventListener('keydown', handleEscape);
    state.form.addEventListener('submit', interceptNativeSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }

  window.addEventListener('load', install);
}());
